import { SESSIE_VERLOPEN } from './fouten';

export class UserModule {
    static async login(username, password) {
        const request = await fetch('api/User/Login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                'username': username,
                'password': password
            })
        });
        return await request.json(); 
    }

    static logout() {
        localStorage.removeItem('token');
        // De gekozen organisatie hoort bij de sessie: bij uitloggen ook weg.
        localStorage.removeItem('actieveOrganisatie');
    }

    static checkIfAuthorized(res) {
        if (res.status !== 401) {
            return res.json();
        }
        else {
            UserModule.logout();
            throw SESSIE_VERLOPEN;
        }
    }

    /** Rollen uit het JWT halen (staat in de payload, zonder handtekeningcontrole:
     *  alleen voor het tonen/verbergen van menu-items - de server bepaalt wat mag). */
    static getRoles() {
        const token = localStorage.getItem('token');
        if (!token) return [];

        try {
            const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
            const claims = JSON.parse(atob(payload.padEnd(payload.length + (4 - payload.length % 4) % 4, '=')));
            const rol = claims['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] ?? claims.role;
            return rol === undefined ? [] : (Array.isArray(rol) ? rol : [rol]);
        } catch {
            return [];
        }
    }

    static isSuperbeheerder() {
        return UserModule.getRoles().includes('Superbeheerder');
    }

    static isLoggedIn() {
        if (localStorage.getItem('token') !== null) {
            return true;
        } else {
            return false;
        }
    }
}